<template lang="pug">
  div
    template(v-if="loaded")
      v-card.mb-3(
        v-for="item in rations"
        :key="item.id")
        .list-mobile
          .list-mobile__top
            v-dropdown(
              width-auto)
              h2.list-mobile__title.list-mobile__title--size-lg.list-mobile__title--underline {{ item.name | shortstr }}
              .list-mobile__table(
                slot="content")
                  v-card.mt-1(
                    elevated)
                    .list-mobile__table-header
                      .list-mobile__table-row
                        .list-mobile__table-cell {{ 'base.name' | translate }}
                        .list-mobile__table-cell {{ 'base.weight' | translate }}
                        .list-mobile__table-cell {{ 'base.dry_metter' | translate }}
                    .list-mobile__table-body
                      template(
                        v-for="(ingredient, index) in item.ingredients")
                        list-item-delete(
                          :key="index"
                          @remove="onRemove(ingredient.id, item)")
                          .list-mobile__table-row
                            .list-mobile__table-cell {{ ingredient.name }}
                            .list-mobile__table-cell
                              template(v-if="!item.is_dry || ingredient.name === 'H2O'")
                                input.mobile-weight-input(
                                  type="number"
                                  :disabled="readOnly"
                                  v-model.number="ingredient.weight"
                                  @blur="saveChanges(item)")
                                span.ml-1 {{ 'base.kg' | translate }}
                              template(v-else)
                                span {{ ingredient.weight }} {{ 'base.kg' | translate }}
                            .list-mobile__table-cell
                              template(v-if="ingredient.name !== 'H2O'")
                                template(v-if="item.is_dry")
                                  input.mobile-weight-input(
                                    type="number"
                                    :disabled="readOnly || ingredient.dry_matter === 0"
                                    :value="dryWeight(ingredient)"
                                    @blur="onDryWeightChange(ingredient, $event); saveChanges(item)")
                                  span.ml-1 {{ 'base.kg' | translate }}
                                template(v-else)
                                  span {{ dryWeight(ingredient) }} {{ 'base.kg' | translate }}
                              template(v-else)
                                span -
            .list-mobile__button
              v-btn(
                :disabled="isConsultant"
                icon
                @click="openEdit")
                v-icon(
                  font-size="1"
                  icon="cog")
          .list-mobile__content
            .list-mobile__item
              .list-mobile__item-label {{ 'base.weight' | translate }} [{{ 'base.kg' | translate }}]
              .list-mobile__item-value {{ totalWeight(item) | rounding }}
            .list-mobile__item
              .list-mobile__item-label {{ 'base.dry_metter' | translate }} [{{ 'base.kg' | translate }}]
              .list-mobile__item-value {{ totalDryWeight(item) | rounding }}
            .list-mobile__item
              .list-mobile__item-label {{ 'base.price' | translate }} [{{ 'base.currency' | translate }}]
              .list-mobile__item-value {{ totalPrice(item) | rounding }}
      v-table-body(
        v-if="loaded"
        outside-table
        :empty="!rations.length")
      v-dialog(
        v-model="dialog"
        max-width="200px")
        v-card
          v-card-title
            h2.card-title {{ 'base.information' | translate }}
          v-card-content
            div.mb-1
              h3 {{ 'base.information_desktop' | translate }}
          v-card-actions
            v-btn(
              @click="dialog = falce") {{ 'base.close' | translate }}
    template(v-else)
      v-card.mb-3(v-for="i in 5" :key="i")
        .list-mobile.list-mobile--skeleton
          .list-mobile__top
            .list-mobile__title-skeleton
            .list-mobile__button-skeleton
          .list-mobile__content
            .list-mobile__item(v-for="j in 3" :key="`${i}-${j}`")
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-1
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-1
    template(v-if="loaded && rations.length")
      ui-pagination(
        v-model="page"
        offset-none
        :count="totalCount"
        @page-change="loadData")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'

import UiPagination from '@/components/ui/ui-pagination/UiPagination.vue'
import UiNumberInput from '@/components/ui/ui-number-input/UiNumberInput.vue'

import ListItemDelete from '@/components/common/list-item-delete/ListItemDelete'

export default {
  name: 'RationsTableMobile',

  components: {
    UiPagination,
    UiNumberInput,
    ListItemDelete
  },

  data: () => ({
    page: 1,
    loaded: false,
    dialog: false,
  }),

  computed: {
    ...mapGetters('rations', [
      'rations',
      'totalCount'
    ]),

    readOnly () {
      return !this.hasPermission('ration', 'change')
    }
  },

  mounted () {
    this.loadData()
  },

  methods: {
    ...mapActions('rations', [
      'loadRations',
      'loadRation',
      'setIngredientWeight'
    ]),

    saveChanges ({ id, ...payload }) {
      if (!this.readOnly) {
        api.rations.updateById(id, payload)
      }
    },

    onDryWeightChange (ingredient, $event) {
      const value = parseFloat($event.target.value)

      if (isNaN(value) || ingredient.dry_matter === 0) {
        ingredient.weight = 0
        return
      }

      const dryMatter = ingredient.dry_matter > 100
        ? ingredient.dry_matter / 10000
        : ingredient.dry_matter / 100

      const weight = value / dryMatter

      // округлення до 2 знаків після коми
      ingredient.weight = Math.round(weight * 100) / 100
    },

    dryWeight (ingredient) {
      return (ingredient.dry_matter > 100)
        ? (Math.round(ingredient.weight * ingredient.dry_matter) / 10000).toFixed(2)
        : (Math.round(ingredient.weight * ingredient.dry_matter) / 100).toFixed(2)
    },

    openEdit () {
      this.dialog = true
    },

    totalWeight (item) {
      const weightReducer = (acc, item) => (acc += item.weight)
      return item.ingredients.reduce(weightReducer, 0)
    },

    totalDryWeight (item) {
      const dryWeightReducer = (acc, item) => {
        const dryMatter = item.dry_matter > 100 ? item.dry_matter / 10000 : item.dry_matter
        return acc + (item.weight * dryMatter / 100)
      }
      return item.ingredients.reduce(dryWeightReducer, 0)
    },

    totalPrice (item) {
      const priceReducer = (acc, item) => (acc += (item.weight * item.price_per_kg))
      return item.ingredients.reduce(priceReducer, 0)
    },

    onRemove (id, ration) {
      const ingredients = ration.ingredients
        .filter(item => item.id !== id)
      const payload = {
        farm: ration.farm,
        full_name: ration.full_name,
        id: ration.id,
        ingredients: ingredients,
        is_dry: ration.is_dry,
        name: ration.name
      }
      this.setIngredientWeight(payload)
    },

    async loadData () {
      const filters = {
        farm: this.$route.params.farm_id,
        page: this.page > 1 ? this.page : null
      }
      await this.loadRations(filters)
      this.loaded = true
    }
  },

  watch: {
    page () {
      this.loaded = false
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-weight-input {
  background-color: #f8f8f8;
  padding: 0.4rem 0.8rem;
  border-radius: 0.4rem;
  font-weight: 500;
  min-width: 4rem;
  text-align: center;
  border: 1px solid #ddd;
  font-size: 0.9rem;

  &:disabled {
    background-color: #e9ecef;
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
}

.ml-1 {
  margin-left: 0.25rem;
}
</style>